import FormAutoComplete from "../yoello-lib/modules/dynamicForms/FormComponents/FormAutoComplete";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";

const inputVariant = "outlined" as const;

export const createVenueTypesFormRows = (
  getVenueTypes: () => any[] | undefined
): IDynamicFormRow[] => {
  return [
    {
      label: "forms.details.venueType",
      keyName: "venue_type_id",
      gridColumnOptions: { formCol: 12 },
      inputProperties: { variant: inputVariant, required: true },
      Component: FormAutoComplete,
      formProps: {
        selectOptions: getVenueTypes(),
      },
      registerOptions: {
        required: true,
      },
    },
  ];
};
